import { Input, InputAdornment } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { getQueryObject } from "../../helpers/urlBuilder";

const SearchInput = ({ onChange }) => {
  const query = getQueryObject();
  const [search, setSearch] = useState(query.search ? query.search.toString() : '');

  const searchDebounced = debounce((searchValue) => {
    onChange(searchValue);
  }, 300);

  useEffect(() => {
    if (query.search) {
      onChange(query.search.toString());
    }
  }, [])

  const onInputChange = (e) => {
    setSearch(e.target.value);
    searchDebounced(e.target.value);
  }

  return (
    <Input
      fullWidth
      variant="outlined"
      disableUnderline
      value={search}
      placeholder="Search"
      onChange={onInputChange}
      startAdornment={
        <InputAdornment position="start">
          <SearchOutlinedIcon />
        </InputAdornment>
      }
    />
  )
}

export default SearchInput;